import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Grid, Label, TextField } from '../../common/components';
import messages from '../messages';

const DescriptionField = ({
  className, field, form, intl, ...otherProps
}) => {
  const error = useMemo(() => !!(
    form.errors[field.name] && form.touched[field.name]
  ), [field.name, form.errors, form.touched]);

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      className={className}
    >
      <Grid item xs={1}>
        <Label
          htmlFor={field.name}
          error={error}
        >
          <FormattedMessage {...messages.descriptionFieldLabel} />
        </Label>
      </Grid>
      <Grid item xs={6}>
        <TextField
          {...field}
          {...otherProps}
          id={field.name}
          placeholder={intl.formatMessage(messages.descriptionFieldPlaceholder)}
          error={error}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

DescriptionField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      description: PropTypes.string,
    }).isRequired,
    touched: PropTypes.shape({
      description: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

DescriptionField.defaultProps = {
  className: undefined,
};

export default injectIntl(DescriptionField);
